import * as Yup from "yup";

export const AddPlayerInitialState = {
  name: "",
  app: "",
  apm: "",
  numShirt: "",
  position: "",
  team: ""
};

export const AddPlayerValidationSchema = Yup.object({
  name: Yup.string().required("Este campo es requerido"),
  app: Yup.string().required("Este campo es requerido"),
  apm: Yup.string().required("Este campo es requerido"),
  numShirt: Yup.number()
    .integer("Solo se aceptan números enteros")
    .min(1, "El número minimo es 1")
    .max(100, "El número máximo es 100")
    .required("Este campo es requerido"),
  position: Yup.string().required("Este campo es requerido")
});
